// Compact "time-since" helper for the sidebar and chat header.
// Renders ≤3 chars: "now" under one minute, then "Nm" / "Nh" / "Nd". Sub-minute
// resolution (e.g. "30s") was removed in Sprint 13 — sidebar timestamps now
// fire only at turn boundaries and seconds carry no actionable signal.
// Edge case E8: the input is a server-generated ISO string, so even if the
// client clock is skewed the relative result is sane to within a few seconds.

const SECOND = 1_000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatRelativeTime(iso: string, now: number = Date.now()): string {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return '—';

  const diff = Math.max(0, now - t);

  if (diff < MINUTE) return 'now';
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h`;
  return `${Math.floor(diff / DAY)}d`;
}

// 10-10 (informe de espacio, punto 8): la oficina habla español y usa 24 h, como la Sala de Control. Antes estas horas
// salían con el idioma del navegador ([]): un navegador en inglés pintaba «06:52 PM». Idioma fijo, nunca el del navegador.
const HORA = new Intl.DateTimeFormat('es-ES', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const FECHA_HORA = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const DIA_MES = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'long' });

function fecha(iso: string | null): Date | string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d;
}

/** Hora de reloj «18:52» (es-ES, 24 h) de un ISO. Sin fecha → «—»; si no se entiende, el texto tal cual. */
export function formatClockTime(iso: string | null): string {
  const d = fecha(iso);
  return typeof d === 'string' ? d : HORA.format(d);
}

/** «10 oct, 18:52» (es-ES, 24 h). */
export function formatFechaHora(iso: string | null): string {
  const d = fecha(iso);
  return typeof d === 'string' ? d : FECHA_HORA.format(d);
}

/** «10 de octubre» (es-ES). */
export function formatDiaMes(iso: string | null): string {
  const d = fecha(iso);
  return typeof d === 'string' ? d : DIA_MES.format(d);
}
